import React from 'react';
import { UnleashService } from '../../../services';
import { Insights, InsightsV2 } from '../components';
import useUnleashHook from '../../../core/unleash/useUnleashHook';

const InsightsContainer = (props) => {
  const { isFlagEnabled } = useUnleashHook(UnleashService.FLAGS.LEARNER_PROFILE_INSIGHTS_V2);

  return isFlagEnabled() ? <InsightsV2 {...props} /> : <Insights {...props} />;
};

export default InsightsContainer;
